import React, { useState, useEffect, useRef, useCallback } from "react";
import { unstable_batchedUpdates } from "react-dom";
import {
  placeToFieldFromHand,
  addToHandFromField,
  placeToTopOfDeckFromField,
  placeToBotOfDeckFromField,
  moveCardOnField,
  moveEvoAndBaseOnField,
  transferToOpponentField,
  placeToCemeteryFromField,
  placeToFieldFromDeck,
  placeToFieldFromCemetery,
  placeToFieldFromBanish,
  placeTokenOnField,
  placeToBanishFromField,
  playCardToSharedZone,
  movePlayedToField,
  setPlayed,
  removeTokenOnField,
  evolveCardOnField,
  advancedToField,
  feedCardOnField,
  rideCardOnField,
  backToEvolveDeck,
  advancedBackToEvolveDeck,
  switchEvoCardOnField,
  setEnemyField,
  setEnemyEvoField,
  setEnemyEngaged,
  setEnemyCemetery,
  setEnemyArt,
  setEnemyEvoDeck,
  setEnemyCustomValues,
  showAtk,
  showDef,
  hideAtk,
  hideDef,
  modifyCounter,
  showStatus,
  hideStatus,
  duplicateCardOnField,
  clearValuesAtIndex,
  moveValuesAtIndex,
  moveCountersAtIndex,
  moveEngagedAtIndex,
  clearStatusAtIndex,
  moveStatusAtIndex,
  clearCountersAtIndex,
  clearEngagedAtIndex,
  setEnemyHand,
  setShowEnemyHand,
  setShowEnemyCard,
  setEnemyCard,
  setEnemyRevealedCards,
  setEnemyRevealedCardsOpen,
  setViewingOpponentTopCards,
  setEnemyDeckSize,
  setEnemyEvoPoints,
  setEnemyTurn,
  setEnemyPlayPoints,
  setEnemyHealth,
  setEnemyLeader,
  setEnemyCounter,
  setEnemyAura,
  setEnemyBane,
  setEnemyWard,
  toggleKeyword,
  setEnemyKeyword,
  setEnemyBanish,
  setEnemyViewingDeck,
  setEnemyViewingHand,
  setEnemyViewingCemetery,
  setEnemyViewingEvoDeck,
  setEnemyViewingCemeteryOpponent,
  setEnemyViewingEvoDeckOpponent,
  setEnemyViewingTopCards,
  setEnemyLeftGame,
  setEnemyRematchStatus,
  setEnemyDice,
  setEnemyLog,
  setEnemyChat,
  setEnemyIdentity,
  setMyIdentity,
  setEnemyOnlineStatus,
  setLastChatMessage,
  setEnemyLeaderActive,
  setEnemySuperEvoActive,
  setField,
  setEnemyCardBack,
  setCardSelectedInHand,
  setEnemyCardSelectedInHand,
  setCardSelectedOnField,
  setEnemyCardSelectedOnField,
  setRoom,
  setSelfOnlineStatus,
  setSelfConnectionState,
  setSelfResyncing,
  restoreOwnState,
  attachEquipmentOnField,
  moveEquipmentAtIndex,
  clearEquipmentAtIndex,
  removeEquipmentOnField,
  setEnemyEquipField,
} from "../../redux/CardSlice";
import { artImage } from "../../decks/getCards";
import { primaryType } from "../../decks/cardDetails";
import { doubleEvoOtherSide } from "../../decks/doubleEvo";
import { motion, MotionConfig } from "framer-motion";
import CardMUI from "@mui/material/Card";
import { useDispatch, useSelector } from "react-redux";
import { Menu, MenuItem, Modal, Box, Typography } from "@mui/material";
import Card from "../hand/Card";
import Deck from "./Deck";
import Cemetery from "./Cemetery";
import PlayedZone from "./PlayedZone";
import EnemyCemetery from "./EnemyCemetery";
// import cardback from "../../assets/cardbacks/default.png";
import EvoDeck from "./EvoDeck";
import EnemyEvoDeck from "./EnemyEvoDeck";
import img from "../../assets/pin_bellringer_angel.png";
import "../../css/AnimatedBorder.css";
import { useNavigate } from "react-router-dom";
import { socket, playerId, getSavedRoom, getSavedState } from "../../sockets";
import {
  useAuth,
  discordName,
  discordAvatar,
} from "../../auth/AuthProvider";
import useSocketStateSync from "../hooks/useSocketStateSync";
import useReceiveFullState from "../hooks/useReceiveFullState";
import useStoreState from "../hooks/useStoreState";
import useHeartbeat from "../hooks/useHeartbeat";
import { useEngineSync } from "../hooks/useEngineSync";
import { useUiChromeVisible, useUiModalOpen } from "../hooks/useUiChromeVisible";
import HideUiButton, { ModalHideUiRow } from "../ui/HideUiButton";
import { setSelectedAttackerId } from "../../redux/GameStateSlice";
import { getNameByCardNoClient } from "../../engine/cardLookup";

import Token from "./Token";
import ShowDice from "./ShowDice";
import { playGameAnimation, triggerGameAnimation } from "./animationBus";
import { DeckFx, HandFx, useShuffleHandActive, useShuffleDeckActive } from "./GameFx";
import {
  registerFieldGrid,
  registerBoardScale,
  registerEnemyFieldGrid,
  registerEnemyHand,
  fieldSlotCenter,
  enemyFieldSlotCenter,
  enemyHandCenter,
  enemyCemeteryCenter,
  getBoardScale,
} from "./handDrag";
import FieldDropHints from "./FieldDropHints";
import DiceRoll from "./DiceRoll";
import PlayReveal from "./PlayReveal";
import {
  triggerCardReveal,
  triggerHandReveal,
  triggerBanishReveal,
  triggerEquipReveal,
  playCardReveal,
  onHideChange,
  isHidden,
} from "./cardRevealBus";

import defaultCardBack from "../../assets/cardbacks/default.png";
import aeneaCardBack from "../../assets/cardbacks/aenea.png";
import dionneCardBack from "../../assets/cardbacks/dionne.png";
import dragonCardBack from "../../assets/cardbacks/dragon.png";
import fileneCardBack from "../../assets/cardbacks/filene.png";
import galmieuxCardBack from "../../assets/cardbacks/galmieux.png";
import jeanneCardBack from "../../assets/cardbacks/jeanne.png";
import kuonCardBack from "../../assets/cardbacks/kuon.png";
import ladicaCardBack from "../../assets/cardbacks/ladica.png";
import lishennaCardBack from "../../assets/cardbacks/lishenna.png";
import lishenna2CardBack from "../../assets/cardbacks/lishenna2.png";
import mistolinaCardBack from "../../assets/cardbacks/mistolina.png";
import monoCardBack from "../../assets/cardbacks/mono.png";
import orchisCardBack from "../../assets/cardbacks/orchis.png";
import piercyeCardBack from "../../assets/cardbacks/piercye.png";
import rosequeenCardBack from "../../assets/cardbacks/rosequeen.png";
import shikiCardBack from "../../assets/cardbacks/shiki.png";
import shutenCardBack from "../../assets/cardbacks/shuten.png";
import tidalgunnerCardBack from "../../assets/cardbacks/tidalgunner.png";
import viridiaCardBack from "../../assets/cardbacks/viridia.png";
import wilbertCardBack from "../../assets/cardbacks/wilbert.png";

const style = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "transparent",
  boxShadow: 24,
  p: 3,
  width: "55%",
};

// Responsive board-scaling constants (see the scaling effect in Field).
// Both rows use the same side-column width so the player's Field/EX slots line
// up exactly under the opponent's. The player's three piles share one column
// via a 2x2 grid; keeping every side column at this width preserves the full
// 5-card slot spacing instead of squeezing the field on one side.
const SIDE_COLUMN_WIDTH = 240;
const BASE_WIDTH = 1400; // 240 + 920 field + 240
// Horizontal inset applied inside each field grid so the outermost cards don't
// touch the side piles. Scales with the board like everything else.
const FIELD_GRID_PADDING_X = 40;
const MIN_SCALE = 0.45;
const MAX_SCALE = 1.5;

// Keyword statuses offered by "Add Status", shown as black boxes on the card.
const KEYWORDS = [
  "Aura",
  "Ward",
  "Bane",
  "Drain",
  "Storm",
  "Rush",
  "Assail",
  "Intimidate",
];

// White Psalm's [lastwords] summons a Black Psalm, so its context menu gets a
// dedicated one-click swap (see handleSummonBlackPsalm).
const WHITE_PSALM = "White Psalm, New Revelation TOKEN";
const BLACK_PSALM = "Black Psalm, New Revelation TOKEN";

export default function Field({
  ready,
  setReady,
  setHovering,
  readyToPlaceOnFieldFromHand,
  setReadyToPlaceOnFieldFromHand,
  onScaleChange,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // redux state
  const reduxRoom = useSelector((state) => state.card.room);
  const reduxField = useSelector((state) => state.card.field);
  const reduxCurrentCard = useSelector((state) => state.card.currentCard);
  const reduxCurrentCardIndex = useSelector(
    (state) => state.card.currentCardIndex,
  );
  const reduxEvoField = useSelector((state) => state.card.evoField);
  const reduxEquipField = useSelector((state) => state.card.equipField);
  const reduxEngaged = useSelector((state) => state.card.engagedField);
  const reduxCustomStatus = useSelector((state) => state.card.customStatus);
  const reduxCustomValues = useSelector((state) => state.card.customValues);
  const reduxEnemyCustomValues = useSelector(
    (state) => state.card.enemyCustomValues,
  );
  const reduxEnemyField = useSelector((state) => state.card.enemyField);
  const reduxEnemyEvoField = useSelector((state) => state.card.enemyEvoField);
  const reduxEnemyEquipField = useSelector(
    (state) => state.card.enemyEquipField,
  );
  const reduxEnemyEngaged = useSelector(
    (state) => state.card.enemyEngagedField,
  );
  const reduxCurrentDeck = useSelector((state) => state.card.deck);
  const reduxCurrentRoom = useSelector((state) => state.card.room);

  // Announce my Discord identity (name/avatar) to the room so the opponent's
  // chat and game log can show it. Re-announced if the login state changes;
  // the reducer also answers the opponent's first announcement, covering the
  // race where one player joins the room after the other has already sent.
  const { user: authUser } = useAuth();
  useEffect(() => {
    if (!reduxCurrentRoom) return;
    dispatch(
      setMyIdentity({
        name: authUser ? discordName(authUser) : "",
        avatar: authUser ? discordAvatar(authUser) : "",
      }),
    );
  }, [authUser, reduxCurrentRoom, dispatch]);
  const reduxEnemyHand = useSelector((state) => state.card.enemyHand);
  // Hide the opponent's hand cards / deck pile while their shuffle riffle plays.
  const enemyShuffling = useShuffleHandActive("enemy");
  const enemyDeckShuffling = useShuffleDeckActive("enemy");
  const reduxEnemyDeckSize = useSelector((state) => state.card.enemyDeckSize);
  const reduxShowEnemyHand = useSelector((state) => state.card.showEnemyHand);
  const reduxShowEnemyCard = useSelector((state) => state.card.showEnemyCard);
  const reduxEnemyCard = useSelector((state) => state.card.enemyCard);
  const reduxEnemyRevealedCards = useSelector(
    (state) => state.card.enemyRevealedCards,
  );
  const reduxEnemyRevealedCardsOpen = useSelector(
    (state) => state.card.enemyRevealedCardsOpen,
  );
  const reduxViewingOpponentTopCards = useSelector(
    (state) => state.card.viewingOpponentTopCards,
  );
  const reduxEnemyArt = useSelector((state) => state.card.enemyArt);
  const reduxCounterField = useSelector((state) => state.card.counterField);
  const reduxExPlayCostField = useSelector((state) => state.card.exPlayCostField);
  const reduxEnemyExPlayCostField = useSelector(
    (state) => state.card.enemyExPlayCostField,
  );
  const reduxEnemyCounterField = useSelector(
    (state) => state.card.enemyCounterField,
  );
  const reduxAuraField = useSelector((state) => state.card.auraField);
  const reduxEnemyAuraField = useSelector((state) => state.card.enemyAuraField);
  const reduxBaneField = useSelector((state) => state.card.baneField);
  const reduxEnemyBaneField = useSelector((state) => state.card.enemyBaneField);
  const reduxWardField = useSelector((state) => state.card.wardField);
  const reduxEnemyWardField = useSelector((state) => state.card.enemyWardField);
  const reduxKeywordField = useSelector((state) => state.card.keywordField);
  const reduxEnemyKeywordField = useSelector(
    (state) => state.card.enemyKeywordField,
  );
  const reduxEnemyCardBack = useSelector((state) => state.card.enemyCardback);
  const reduxCardSelectedInHand = useSelector(
    (state) => state.card.cardSelectedInHand,
  );
  const reduxCardSelectedOnField = useSelector(
    (state) => state.card.cardSelectedOnField,
  );
  const gameMode = useSelector((state) => state.gameState.gameMode);
  const automated = gameMode === "automated";
  const fieldInstanceIds = useSelector((state) => state.card.fieldInstanceIds);
  const enemyFieldInstanceIds = useSelector((state) => state.card.enemyFieldInstanceIds);
  const legalActions = useSelector((state) => state.gameState.legalActions);
  const selectedAttackerId = useSelector((state) => state.gameState.selectedAttackerId);
  const leaderActive = useSelector((state) => state.card.leaderActive);
  const pendingChoices = useSelector((state) => state.gameState.pendingChoices);
  const engineView = useSelector((state) => state.gameState.engineView);
  const playerSlot = useSelector((state) => state.gameState.playerSlot);
  const { sendAction } = useEngineSync();
  const chromeVisible = useUiChromeVisible();
  const enemyCardModalOpen = useUiModalOpen(reduxShowEnemyCard);
  const enemyRevealedCardsModalOpen = useUiModalOpen(
    reduxEnemyRevealedCardsOpen,
  );

  // useState
  const [cardback, setCardback] = useState();
  const [contextMenu, setContextMenu] = useState(null);
  const [contextEvoMenu, setContextEvoMenu] = useState(null);
  const [index, setIndex] = useState(0);
  const [deckIndex, setDeckIndex] = useState(0);
  const [name, setName] = useState("");
  const [readyToMoveOnField, setReadyToMoveOnField] = useState(false);
  const [readyToMoveEvoOnField, setReadyToMoveEvoOnField] = useState(false);
  const [readyToDuplicateOnField, setReadyToDuplicateOnField] = useState(false);
  const [readyFromDeck, setReadyFromDeck] = useState(false);
  const [readyFromCemetery, setReadyFromCemetery] = useState(false);
  const [readyFromBanish, setReadyFromBanish] = useState(false);
  const [readyFromPlayed, setReadyFromPlayed] = useState(false);
  const [readyToEvo, setReadyToEvo] = useState(false);
  const [readyToAdvanced, setReadyToAdvanced] = useState(false);
  const [readyToFeed, setReadyToFeed] = useState(false);
  const [readyToRide, setReadyToRide] = useState(false);
  const [tokenReady, setTokenReady] = useState(false);
  const [automatedFieldMenu, setAutomatedFieldMenu] = useState(null);

  // --- Responsive board scaling -------------------------------------------
  // The board is authored at a fixed "design size" (BASE_WIDTH x its natural
  // height) with many pixel-tuned overlays (atk/def, counters, deck counts).
  // Instead of re-tuning every nested value per breakpoint, we scale the whole
  // board uniformly to fit the available width and the viewport height. Because
  // every card and overlay scales together, alignment is preserved exactly at
  // any laptop / monitor / iPad resolution.
  const boardWrapperRef = useRef(null);
  const boardRef = useRef(null);
  const [boardScale, setBoardScale] = useState(1);

  // Share the live board scale with the drag layer so dragged field cards track
  // the cursor 1:1 and their drop points map back to viewport coords (see
  // handDrag.js / the MotionConfig wrapping the player field grid below).
  useEffect(() => {
    registerBoardScale(boardScale);
  }, [boardScale]);

  // Map pointer coords into the board's local (scaled) space for framer-motion's
  // drag, so a dragged field card follows the cursor exactly. Stable per scale so
  // MotionConfig doesn't recreate its context (and re-render the cards) each render.
  const transformPagePoint = useCallback(
    (point) => ({ x: point.x / (boardScale || 1), y: point.y / (boardScale || 1) }),
    [boardScale]
  );

  // Re-render when the set of mid-reveal (hidden) field slots changes, so a
  // played card pops into view exactly when its reveal animation lands.
  const [, bumpHidden] = useState(0);
  useEffect(() => onHideChange(() => bumpHidden((n) => n + 1)), []);

  useEffect(() => {
    const wrapper = boardWrapperRef.current;
    const board = boardRef.current;
    if (!wrapper || !board) return;

    const update = () => {
      // The wrapper already excludes both hands: the opponent's hand is a
      // sibling above it and the player's hand is outside Field entirely. Using
      // its real size (instead of fixed viewport reserves) lets the board fill
      // all the space between the hands and keeps the field large at every
      // resolution.
      const availWidth = wrapper.clientWidth;
      const availHeight = wrapper.clientHeight;
      const naturalHeight = board.offsetHeight; // field rows, unaffected by the transform
      if (!availWidth || !naturalHeight) return;
      const fit = Math.min(availWidth / BASE_WIDTH, availHeight / naturalHeight);
      const scale = Math.max(MIN_SCALE, Math.min(fit, MAX_SCALE));
      setBoardScale(scale);
      // Report the scale up so sibling UI (HP, leader, play points, chat) can
      // shrink by the same factor and stay visually consistent with the board.
      if (onScaleChange) onScaleChange(scale);
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(wrapper);
    ro.observe(board);
    window.addEventListener("resize", update);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [onScaleChange]);

  useSocketStateSync();
  useReceiveFullState();
  useStoreState();
  useHeartbeat();

  useEffect(() => {
    const handleReconnect = () => {
      if (!reduxRoom) return;
      console.log("Reconnected with socket id:", socket.id);
      if (automated) {
        socket.emit("request_engine_state");
        return;
      }
      socket.emit("rejoin_room", reduxRoom);
      socket.emit("request_stored_state", { room: reduxRoom, playerId });
    };

    if (socket.connected) {
      handleReconnect();
    }

    socket.on("connect", handleReconnect);

    return () => {
      socket.off("connect", handleReconnect);
    };
  }, [reduxRoom, automated]);

  // Per-sender sequence tracking for gap detection: { [senderId]: lastSeq }
  const lastSeqBySenderRef = useRef({});
  // Throttle full-state resync requests so a burst of gaps can't storm.
  const lastResyncRef = useRef(0);
  // Fallback timer to clear the "Resyncing…" badge if no peer state comes back.
  const resyncTimerRef = useRef(null);

  const requestResync = useCallback(() => {
    if (!reduxRoom) return;
    const now = Date.now();
    if (now - lastResyncRef.current < 1500) return;
    lastResyncRef.current = now;
    console.log("[resync] requesting full state from opponent");
    dispatch(setSelfResyncing(true));
    // Safety net: the request is answered by the opponent (via receive_full_state),
    // so it'll go unanswered if they're offline. Clear the indicator regardless
    // after a few seconds; the normal path clears it earlier on receipt.
    if (resyncTimerRef.current) clearTimeout(resyncTimerRef.current);
    resyncTimerRef.current = setTimeout(() => {
      dispatch(setSelfResyncing(false));
    }, 4000);
    socket.emit("request_state", { room: reduxRoom });
  }, [reduxRoom, dispatch]);

  // Clear the fallback timer on unmount.
  useEffect(() => {
    return () => {
      if (resyncTimerRef.current) clearTimeout(resyncTimerRef.current);
    };
  }, []);

  // Process a single update (batched with others)
  const handleUpdate = useCallback(
    (update) => {
      switch (update.type) {
        case "field":
          dispatch(setEnemyField(update.data));
          break;
        case "equipField":
          dispatch(setEnemyEquipField(update.data));
          break;
        case "evoField":
          dispatch(setEnemyEvoField(update.data));
          break;
        case "engaged":
          dispatch(setEnemyEngaged(update.data));
          break;
        case "cemetery":
          dispatch(setEnemyCemetery(update.data));
          break;
        case "played":
          dispatch(setPlayed(update.data));
          break;
        case "evoDeck":
          dispatch(setEnemyEvoDeck(update.data));
          break;
        case "values":
          dispatch(setEnemyCustomValues(update.data));
          break;
        case "hand":
          dispatch(setEnemyHand(update.data));
          break;
        case "deckSize":
          dispatch(setEnemyDeckSize(update.data));
          break;
        case "evoPoints":
          dispatch(setEnemyEvoPoints(update.data));
          break;
        case "turn":
          dispatch(setEnemyTurn(update.data));
          break;
        case "playPoints":
          dispatch(setEnemyPlayPoints(update.data));
          break;
        case "health":
          dispatch(setEnemyHealth(update.data));
          break;
        case "leader":
          dispatch(setEnemyLeader(update.data));
          break;
        case "showHand":
          dispatch(setShowEnemyHand(update.data));
          break;
        case "revealTopCards":
          // Only the revealer sees the "Viewing Opponent's Top Cards" toast, so
          // the viewer just opens the modal with the revealed cards.
          if (reduxEnemyRevealedCardsOpen) break;
          dispatch(setEnemyRevealedCards(update.data));
          dispatch(setEnemyRevealedCardsOpen(true));
          break;
        case "revealTopCardsClose":
          dispatch(setEnemyRevealedCardsOpen(false));
          dispatch(setViewingOpponentTopCards(false));
          break;
        case "showCard":
          dispatch(setShowEnemyCard(update.data));
          break;
        case "cardRevealed":
          dispatch(setEnemyCard(update.data));
          break;
        case "transfer":
          dispatch(setField(update.data));
          break;
        case "counter":
          dispatch(setEnemyCounter(update.data));
          break;
        case "aura":
          dispatch(setEnemyAura(update.data));
          break;
        case "bane":
          dispatch(setEnemyBane(update.data));
          break;
        case "ward":
          dispatch(setEnemyWard(update.data));
          break;
        case "keyword":
          dispatch(setEnemyKeyword(update.data));
          break;
        case "banish":
          dispatch(setEnemyBanish(update.data));
          break;
        case "art":
          // Opponent swapped decks: their new per-card art choices become our
          // enemy art so their cards render with the right printings.
          dispatch(setEnemyArt(update.data));
          break;
        case "viewingHand":
          dispatch(setEnemyViewingHand(update.data));
          break;
        case "viewingDeck":
          dispatch(setEnemyViewingDeck(update.data));
          break;
        case "viewingTopCards":
          dispatch(setEnemyViewingTopCards(update.data));
          break;
        case "viewingCemetery":
          dispatch(setEnemyViewingCemetery(update.data));
          break;
        case "viewingEvoDeck":
          dispatch(setEnemyViewingEvoDeck(update.data));
          break;
        case "viewingCemeteryOpponent":
          dispatch(setEnemyViewingCemeteryOpponent(update.data));
          break;
        case "viewingEvoDeckOpponent":
          dispatch(setEnemyViewingEvoDeckOpponent(update.data));
          break;
        case "dice":
          dispatch(setEnemyDice(update.data));
          break;
        case "leaderActive":
          dispatch(setEnemyLeaderActive(update.data));
          break;
        case "superEvoActive":
          dispatch(setEnemySuperEvoActive(update.data));
          break;
        case "log":
          dispatch(setEnemyLog(update.data));
          break;
        case "cardback":
          dispatch(setEnemyCardBack(update.data));
          break;
        case "rematch":
          dispatch(setEnemyRematchStatus(update.data));
          break;
        case "cardSelected":
          dispatch(setEnemyCardSelectedInHand(update.data));
          break;
        case "cardSelectedField":
          dispatch(setEnemyCardSelectedOnField(update.data));
          break;
        case "chat":
          dispatch(setEnemyChat(update.data));
          dispatch(setLastChatMessage(update.data));
          break;
        case "identity":
          dispatch(setEnemyIdentity(update.data));
          break;
        case "animate":
          // Cosmetic-only effect the opponent played (draw / shuffle / evolve).
          // Replay it on their half of our board so both players see it.
          playGameAnimation({ kind: update.data, side: "enemy" });
          break;
        case "cardToHand": {
          // Opponent added a card to hand — fly it up to their hand (the top
          // hand on our screen). A face-down add shows their cardback instead
          // of the card face, so the card's identity stays hidden.
          const handData = update.data || {};
          playCardReveal({
            name: handData.name ?? "Card",
            side: "enemy",
            kind: "hand",
            target: enemyHandCenter(),
            src: handData.faceDown ? cardback : undefined,
          });
          break;
        }
        case "cardMilled":
          // Opponent milled their top card — reveal it centre-screen and sink
          // it into their (top) cemetery pile.
          playCardReveal({
            name: (update.data || {}).name,
            side: "enemy",
            kind: "mill",
            target: enemyCemeteryCenter(),
          });
          break;
        case "cardBanished": {
          // Opponent banished a field card — disintegrate it in place at its
          // slot (mapped to our enemy grid).
          const { name: banName, index: banIndex } = update.data || {};
          const cell = banIndex < 5 ? banIndex + 5 : banIndex - 5;
          playCardReveal({
            name: banName,
            side: "enemy",
            kind: "banish",
            source: enemyFieldSlotCenter(cell),
            size: 161 * getBoardScale(),
          });
          break;
        }
        case "cardPlayed": {
          // Opponent played a card to the field — reveal it centre-screen and
          // fly it onto its slot on their (top) board; the card stays hidden
          // there until the reveal lands. Their field index maps to our enemy
          // grid cell via cardPos.
          const { name: playedName, index: playedIndex } = update.data || {};
          // Map their field index to our enemy-grid cell (same as cardPos).
          const cell = playedIndex < 5 ? playedIndex + 5 : playedIndex - 5;
          playCardReveal({
            name: playedName,
            side: "enemy",
            index: playedIndex,
            target: enemyFieldSlotCenter(cell),
          });
          break;
        }
        case "cardEquipped": {
          // Opponent attached an equipment token to a follower — fly it onto
          // that follower's slot on their (top) board with the golden flash.
          const { name: equipName, index: equipIndex } = update.data || {};
          const cell = equipIndex < 5 ? equipIndex + 5 : equipIndex - 5;
          playCardReveal({
            name: equipName,
            side: "enemy",
            kind: "equip",
            target: enemyFieldSlotCenter(cell),
          });
          break;
        }
        case "full_state_sync":
          // Handle full state synchronization (used on reconnection)
          // This bypasses the queue and directly updates all state
          const fullState = update.data;
          if (fullState) {
            unstable_batchedUpdates(() => {
              if (fullState.enemyField !== undefined)
                dispatch(setEnemyField(fullState.enemyField));
              if (fullState.enemyEvoField !== undefined)
                dispatch(setEnemyEvoField(fullState.enemyEvoField));
              if (fullState.enemyEquipField !== undefined)
                dispatch(setEnemyEquipField(fullState.enemyEquipField));
              if (fullState.enemyHand !== undefined)
                dispatch(setEnemyHand(fullState.enemyHand));
              if (fullState.enemyLeader !== undefined)
                dispatch(setEnemyLeader(fullState.enemyLeader));
              if (fullState.enemyHealth !== undefined)
                dispatch(setEnemyHealth(fullState.enemyHealth));
              if (fullState.enemyPlayPoints !== undefined)
                dispatch(setEnemyPlayPoints(fullState.enemyPlayPoints));
              if (fullState.enemyEvoPoints !== undefined)
                dispatch(setEnemyEvoPoints(fullState.enemyEvoPoints));
              if (fullState.enemyTurn !== undefined)
                dispatch(setEnemyTurn(fullState.enemyTurn));
              if (fullState.enemyDeckSize !== undefined)
                dispatch(setEnemyDeckSize(fullState.enemyDeckSize));
              if (fullState.enemyCemetery !== undefined)
                dispatch(setEnemyCemetery(fullState.enemyCemetery));
              if (fullState.played !== undefined)
                dispatch(setPlayed(fullState.played));
              if (fullState.enemyCardBack !== undefined)
                dispatch(setEnemyCardBack(fullState.enemyCardBack));
              if (fullState.enemyCounter !== undefined)
                dispatch(setEnemyCounter(fullState.enemyCounter));
              if (fullState.enemyAura !== undefined)
                dispatch(setEnemyAura(fullState.enemyAura));
              if (fullState.enemyBane !== undefined)
                dispatch(setEnemyBane(fullState.enemyBane));
              if (fullState.enemyWard !== undefined)
                dispatch(setEnemyWard(fullState.enemyWard));
              if (fullState.enemyKeyword !== undefined)
                dispatch(setEnemyKeyword(fullState.enemyKeyword));
              if (fullState.enemyBanish !== undefined)
                dispatch(setEnemyBanish(fullState.enemyBanish));
              if (fullState.enemyCustomValues !== undefined)
                dispatch(setEnemyCustomValues(fullState.enemyCustomValues));
              if (fullState.enemyDice !== undefined)
                dispatch(setEnemyDice(fullState.enemyDice));
              if (fullState.enemyLeaderActive !== undefined)
                dispatch(setEnemyLeaderActive(fullState.enemyLeaderActive));
              if (fullState.enemySuperEvoActive !== undefined)
                dispatch(setEnemySuperEvoActive(fullState.enemySuperEvoActive));
              if (fullState.enemyLog !== undefined)
                dispatch(setEnemyLog(fullState.enemyLog));
            });
          }
          break;
        case "heartbeat":
          // Liveness ping (see useHeartbeat). Carries no state — its only job is
          // to advance the sender's sequence number so the gap detector in
          // handleMessage can spot a lost prior message. Nothing to apply here.
          break;
        default:
          console.warn("Unknown update type:", update.type);
      }
    },
    [dispatch, reduxEnemyRevealedCardsOpen, cardback],
  );

  // Apply a single message (which may carry one update or a batch of updates).
  // Every update carries the full new value of a field (last-write-wins), so
  // applying the newest message is always safe — the only risk is a *missing*
  // field update, which gap detection in handleMessage repairs via resync.
  const applyMessage = useCallback(
    (message) => {
      if (message.updates && Array.isArray(message.updates)) {
        unstable_batchedUpdates(() => {
          message.updates.forEach((update) => handleUpdate(update));
        });
      } else {
        unstable_batchedUpdates(() => handleUpdate(message));
      }
    },
    [handleUpdate],
  );

  useEffect(() => {
    const handleMessage = (data) => {
      const sender = data._from;
      const seq = data._seq;

      // Legacy / untagged message (no sequence info) — just apply it.
      if (sender === undefined || seq === undefined) {
        applyMessage(data);
        return;
      }

      const seen = lastSeqBySenderRef.current;
      const last = seen[sender];

      if (last === undefined) {
        // First message from this opponent this session. If it doesn't start
        // at 1, or another opponent id was already tracked (opponent
        // reconnected with a new socket id), we may have missed earlier
        // updates — pull a full state to be safe.
        const sawOtherSender = Object.keys(seen).length > 0;
        seen[sender] = seq;
        applyMessage(data);
        if (seq > 1 || sawOtherSender) requestResync();
        return;
      }

      if (seq === last) {
        // Exact duplicate (e.g. a replayed packet) — ignore.
        return;
      }

      if (seq < last) {
        // Sequence went backwards => the server/socket counter reset
        // (server restart or socket reuse). Re-baseline and resync.
        seen[sender] = seq;
        applyMessage(data);
        requestResync();
        return;
      }

      if (seq > last + 1) {
        // Gap: one or more updates were lost. Apply the newest value, then
        // resync to repair any field whose only update fell in the gap.
        seen[sender] = seq;
        applyMessage(data);
        requestResync();
        return;
      }

      // In order (seq === last + 1).
      seen[sender] = seq;
      applyMessage(data);
    };

    socket.on("receive msg", handleMessage);
    socket.on("online", () => {
      dispatch(setEnemyOnlineStatus(true));
      // If they'd left and now rejoined, drop the "left game" notice.
      dispatch(setEnemyLeftGame(false));
    });
    socket.on("offline", () => dispatch(setEnemyOnlineStatus(false)));
    // Explicit "Exit Game" by the opponent (no socket drop, so no `offline`).
    socket.on("opponent_left", () => dispatch(setEnemyLeftGame(true)));

    return () => {
      socket.off("receive msg", handleMessage);
      socket.off("online");
      socket.off("offline");
      socket.off("opponent_left");
    };
  }, [dispatch, applyMessage, requestResync]);

  useEffect(() => {
    if (reduxCurrentRoom.length === 0) {
      // The `card` slice isn't persisted, so a hard reload lands here with an
      // empty room. If we remembered a room (i.e. the player didn't explicitly
      // leave), restore it and let the reconnect effect rejoin + pull state,
      // instead of bouncing back to the home screen.
      const saved = getSavedRoom();
      if (saved) {
        dispatch(setRoom(saved));
        // Restore the player's OWN board immediately from this tab's saved
        // snapshot, before any server round-trip. This is what makes the board
        // survive a reload even if the server restarted and lost its copy. The
        // reconnect effect still rejoins + pulls the opponent's live state.
        const savedState = getSavedState(saved);
        if (savedState) dispatch(restoreOwnState(savedState));
      } else {
        navigate("/");
      }
    }
  }, [reduxCurrentRoom, navigate, dispatch]);

  // Track this client's own connection so the UI can show a disconnected
  // indicator (the WifiOff icon) while we're offline / reconnecting.
  useEffect(() => {
    const onConnect = () => {
      dispatch(setSelfOnlineStatus(true));
      dispatch(setSelfConnectionState("online"));
    };
    const onDisconnect = (reason) => {
      dispatch(setSelfOnlineStatus(false));
      // Socket.io auto-reconnects on transport-level drops, but NOT when the
      // disconnect was explicitly initiated by either side ("io server/client
      // disconnect") — those stay down until a manual reconnect. Label the
      // badge accordingly: "Reconnecting" when a retry is underway, otherwise
      // a flat "Disconnected".
      const willRetry =
        reason !== "io server disconnect" && reason !== "io client disconnect";
      dispatch(setSelfConnectionState(willRetry ? "reconnecting" : "disconnected"));
    };
    // Manager-level event: fires on each automatic reconnection attempt, so we
    // keep showing "Reconnecting" for the whole retry sequence.
    const onReconnectAttempt = () =>
      dispatch(setSelfConnectionState("reconnecting"));
    dispatch(setSelfOnlineStatus(socket.connected));
    dispatch(setSelfConnectionState(socket.connected ? "online" : "reconnecting"));
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.io.on("reconnect_attempt", onReconnectAttempt);
    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.io.off("reconnect_attempt", onReconnectAttempt);
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(setCardSelectedInHand(-1));
  }, [reduxEnemyHand, dispatch]);

  useEffect(() => {
    dispatch(setCardSelectedOnField(-1));
  }, [reduxEnemyField, dispatch]);

  const handleShowCardModalClose = () => {
    dispatch(setShowEnemyCard(false));
  };

  const handleShowRevealedCardsModalClose = () => {
    socket.emit("send msg", {
      type: "revealTopCardsClose",
      data: true,
      room: reduxRoom,
    });
    dispatch(setEnemyRevealedCardsOpen(false));
    dispatch(setViewingOpponentTopCards(false));
  };

  const cardPos = (idx) => {
    if (idx === -1) return -1;
    else if (idx < 5) return idx + 5;
    else return idx - 5;
  };

  const isToken = (name) => {
    return name.slice(-5) === "TOKEN";
  };
  const isAdvanced = (name) => {
    return name.slice(-8) === "ADVANCED";
  };
  // Does this slot have an equipment token attached? Equipment lives in its
  // own equipField array, so it coexists with evolves.
  const hasEquipAt = (i) => reduxEquipField[i] !== 0 && !!reduxEquipField[i];

  const handleClick = (name, indexClicked) => {
    // The card placed onto an empty slot this click (any source), so the
    // "played" reveal fires once at the end — but only for the field itself
    // (top row, indices 0-4), never the EX area (bottom row, 5-9).
    let playedCard = null;
    if (reduxField[indexClicked] === 0 && !readyToEvo && !readyToFeed) {
      if (readyToPlaceOnFieldFromHand) {
        setReadyToPlaceOnFieldFromHand(false);
        dispatch(
          placeToFieldFromHand({
            card: reduxCurrentCard,
            indexInHand: reduxCurrentCardIndex,
            index: indexClicked,
          }),
        );
        playedCard = reduxCurrentCard;
      }
      if (tokenReady) {
        setTokenReady(false);
        dispatch(
          placeTokenOnField({
            card: name,
            index: indexClicked,
          }),
        );
        playedCard = name;
        // dispatch(clearValuesAtIndex(index));
        // dispatch(clearEngagedAtIndex(index));
        // dispatch(clearCountersAtIndex(index));
      }
      if (readyToAdvanced) {
        setReadyToAdvanced(false);
        dispatch(
          advancedToField({
            card: name,
            indexInEvolveDeck: reduxCurrentCardIndex,
            index: indexClicked,
          }),
        );
        playedCard = name;
      }
      if (readyToMoveOnField) {
        setReadyToMoveOnField(false);
        dispatch(
          moveCardOnField({
            card: name,
            prevIndex: index,
            index: indexClicked,
          }),
        );
        // An attached equipment marker travels with its follower (no-op when
        // the slot has none).
        dispatch(
          moveEquipmentAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveValuesAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveCountersAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveEngagedAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveStatusAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(clearValuesAtIndex(index));
        dispatch(clearEngagedAtIndex(index));
        dispatch(clearCountersAtIndex(index));
        dispatch(clearStatusAtIndex(index));
        // Reveal when promoting a card from the EX area (5-9) up to the field.
        if (index >= 5) playedCard = name;
      }
      if (readyToMoveEvoOnField) {
        setReadyToMoveEvoOnField(false);
        dispatch(
          moveEvoAndBaseOnField({
            card: name,
            evoCard: name,
            prevIndex: index,
            index: indexClicked,
          }),
        );
        // An attached equipment travels with its follower (no-op when the
        // slot has none).
        dispatch(
          moveEquipmentAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveValuesAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveCountersAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveEngagedAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(
          moveStatusAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        dispatch(clearValuesAtIndex(index));
        dispatch(clearEngagedAtIndex(index));
        dispatch(clearCountersAtIndex(index));
        dispatch(clearStatusAtIndex(index));
        // Reveal when promoting an evolved card from the EX area up to the field.
        if (index >= 5) playedCard = name;
      }
      if (readyToDuplicateOnField) {
        setReadyToDuplicateOnField(false);
        dispatch(
          duplicateCardOnField({
            card: name,
            index: indexClicked,
          }),
        );
        dispatch(
          moveValuesAtIndex({
            prevIndex: index,
            index: indexClicked,
          }),
        );
        // dispatch(clearValuesAtIndex(indexClicked));
        dispatch(clearEngagedAtIndex(indexClicked));
        dispatch(clearCountersAtIndex(indexClicked));
      }
      if (readyFromDeck) {
        setReadyFromDeck(false);
        console.log("name", name);
        console.log("indexClicked", indexClicked);
        dispatch(
          placeToFieldFromDeck({
            card: name,
            index: indexClicked,
            deckIndex: deckIndex,
          }),
        );
        playedCard = name;
      }
      if (readyFromCemetery) {
        setReadyFromCemetery(false);
        dispatch(
          placeToFieldFromCemetery({
            card: name,
            indexInHand: reduxCurrentCardIndex,
            index: indexClicked,
          }),
        );
        playedCard = name;
      }
      if (readyFromBanish) {
        setReadyFromBanish(false);
        dispatch(
          placeToFieldFromBanish({
            card: name,
            indexInHand: reduxCurrentCardIndex,
            index: indexClicked,
          }),
        );
        playedCard = name;
      }
      if (readyFromPlayed) {
        setReadyFromPlayed(false);
        dispatch(
          movePlayedToField({
            indexInPlayed: reduxCurrentCardIndex,
            index: indexClicked,
          }),
        );
        playedCard = name;
      }
      // Reveal a card played to the field (top row only; EX area 5-9 is silent).
      if (playedCard !== null && indexClicked < 5)
        triggerCardReveal(
          playedCard,
          reduxCurrentRoom,
          indexClicked,
          fieldSlotCenter(indexClicked),
        );
    } else if (
      (readyToFeed || readyToEvo || readyToRide) &&
      reduxField[indexClicked] !== 0 &&
      reduxEvoField[indexClicked] === 0
    ) {
      if (readyToEvo) {
        setReadyToEvo(false);
        dispatch(
          evolveCardOnField({
            card: name,
            indexInEvolveDeck: reduxCurrentCardIndex,
            index: indexClicked,
          }),
        );
        // Use the same reveal as playing a card to the field: the evolved card
        // shows large in the centre, dissolves into particles that fly to its
        // slot, and materialises there (the slot stays hidden until it lands).
        triggerCardReveal(
          name,
          reduxCurrentRoom,
          indexClicked,
          fieldSlotCenter(indexClicked),
        );
        // Play the leader's evolve reaction (LeaderSpine listens for "evolve" on
        // the animation bus). This no longer draws the golden burst — the
        // EvoLayer was removed — so only the leader animates.
        triggerGameAnimation("evolve", reduxCurrentRoom);
      }
      if (readyToRide) {
        setReadyToRide(false);
        dispatch(
          rideCardOnField({
            card: name,
            index: indexClicked,
            indexInEvolveDeck: reduxCurrentCardIndex,
          }),
        );
      }
      if (readyToFeed) {
        setReadyToFeed(false);
        dispatch(
          feedCardOnField({
            card: name,
            index: indexClicked,
            carrots: 1,
            indexInEvolveDeck: reduxCurrentCardIndex,
          }),
        );
      }
    } else if (
      readyToFeed &&
      reduxField[indexClicked] !== 0 &&
      reduxEvoField[indexClicked].slice(0, 6) === "Carrot"
    ) {
      dispatch(
        feedCardOnField({
          card: name,
          index: indexClicked,
          carrots: 2,
          indexInEvolveDeck: reduxCurrentCardIndex,
        }),
      );
    } else {
      console.log("there is already a card here");
      setReadyToEvo(false);
      setReadyToAdvanced(false);
      setReadyToFeed(false);
      setReadyFromCemetery(false);
      setReadyFromBanish(false);
      setReadyFromPlayed(false);
      setReadyToPlaceOnFieldFromHand(false);
      setReadyToMoveOnField(false);
      setReadyToMoveEvoOnField(false);
      setTokenReady(false);
    }
    setReady(false);
  };

  const cancelClick = () => {
    setReady(false);

    setReadyToEvo(false);
    setReadyToAdvanced(false);
    setReadyToFeed(false);
    setReadyFromCemetery(false);
    setReadyFromBanish(false);
    setReadyFromPlayed(false);
    setReadyToPlaceOnFieldFromHand(false);
    setReadyToMoveOnField(false);
    setReadyToMoveEvoOnField(false);
    setTokenReady(false);
  };

  const handleContextMenu = (event, index, name) => {
    setIndex(index);
    setName(name);
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null,
    );
  };
  const handleEvoContextMenu = (event, index, name) => {
    setIndex(index);
    setName(name);
    event.preventDefault();
    setContextEvoMenu(
      contextEvoMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null,
    );
  };
  const handleClose = () => {
    setContextMenu(null);
  };
  const handleEvoClose = () => {
    setContextEvoMenu(null);
  };
  const handleCardToHandFromField = () => {
    handleClose();
    dispatch(
      addToHandFromField({
        card: name,
        index: index,
      }),
    );
    dispatch(clearEquipmentAtIndex(index));
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
    triggerHandReveal(name, reduxCurrentRoom);
  };
  const handleCardToTopDeck = () => {
    handleClose();
    dispatch(
      placeToTopOfDeckFromField({
        card: name,
        index: index,
      }),
    );
    dispatch(clearEquipmentAtIndex(index));
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
  };
  const handleCardToBotDeck = () => {
    handleClose();
    dispatch(
      placeToBotOfDeckFromField({
        card: name,
        index: index,
      }),
    );
    dispatch(clearEquipmentAtIndex(index));
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
  };
  const handleRemoveTokenFromField = () => {
    handleClose();
    dispatch(
      removeTokenOnField({
        card: name,
        index: index,
      }),
    );
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
  };
  // The Psalm tokens only: play their [lastwords] in one click — remove the
  // Psalm on the field and put its counterpart into the same slot.
  const handleSummonPsalm = (token) => {
    handleClose();
    dispatch(
      removeTokenOnField({
        card: name,
        index: index,
      }),
    );
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
    dispatch(
      placeTokenOnField({
        card: token,
        index: index,
      }),
    );
    if (index < 5)
      triggerCardReveal(token, reduxCurrentRoom, index, fieldSlotCenter(index));
  };
  const handleDuplicateToken = () => {
    handleClose();
    setReady(true);
    setReadyToDuplicateOnField(true);
  };

  const handleCardToCemetery = () => {
    handleClose();
    dispatch(
      placeToCemeteryFromField({
        card: name,
        index: index,
      }),
    );
    dispatch(clearEquipmentAtIndex(index));
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
  };
  const handleCardToPlayedZone = () => {
    handleClose();
    if (reduxEvoField[index] !== 0)
      dispatch(backToEvolveDeck({ card: reduxEvoField[index], index }));
    dispatch(
      playCardToSharedZone({
        card: name,
        index: index,
        from: "field",
      }),
    );
    dispatch(clearEquipmentAtIndex(index));
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
  };
  const handleCardToBanish = () => {
    handleClose();
    triggerBanishReveal(name, reduxCurrentRoom, index);
    dispatch(
      placeToBanishFromField({
        card: name,
        index: index,
      }),
    );
    dispatch(clearEquipmentAtIndex(index));
    dispatch(clearValuesAtIndex(index));
    dispatch(clearEngagedAtIndex(index));
    dispatch(clearCountersAtIndex(index));
    dispatch(clearStatusAtIndex(index));
  };

  const handleRemoveEquipment = () => {
    handleClose();
    handleEvoClose();
    dispatch(removeEquipmentOnField(index));
  };

  const handleShowAtkDef = () => {
    handleClose();
    handleEvoClose();
    dispatch(showAtk(index));
    dispatch(showDef(index));
  };

  const handleHideAtkDef = () => {
    handleClose();
    handleEvoClose();
    dispatch(hideAtk(index));
    dispatch(hideDef(index));
  };

  const handleShowStatus = () => {
    // handleClose();
    // handleEvoClose();
    dispatch(showStatus(index));
  };

  const handleHideStatus = () => {
    // handleClose();
    // handleEvoClose();
    dispatch(hideStatus(index));
  };

  // Toggle a keyword status (Aura/Ward/Bane/Drain/Storm/Rush/Assail/
  // Intimidate) on the card,
  // shown as a black box. The context menu is deliberately left OPEN here so
  // several keywords can be checked in one go; other menu items still close it.
  const handleToggleKeyword = (keyword) => {
    dispatch(showStatus(index));
    dispatch(toggleKeyword({ index, keyword }));
  };

  const handleAddCounter = () => {
    handleClose();
    handleEvoClose();
    dispatch(
      modifyCounter({
        value: 1,
        index: index,
      }),
    );
  };

  // Shared move logic (base or evo) used by drag-to-move. Mirrors the
  // readyToMove* click flow: move the card plus its values/counters/engaged/
  // status to the new slot, then clear the old slot.
  const moveFieldCard = (cardName, fromIndex, toIndex, isEvo) => {
    if (isEvo) {
      dispatch(
        moveEvoAndBaseOnField({
          card: cardName,
          evoCard: cardName,
          prevIndex: fromIndex,
          index: toIndex,
        }),
      );
    } else {
      dispatch(
        moveCardOnField({ card: cardName, prevIndex: fromIndex, index: toIndex }),
      );
    }
    dispatch(moveValuesAtIndex({ prevIndex: fromIndex, index: toIndex }));
    dispatch(moveCountersAtIndex({ prevIndex: fromIndex, index: toIndex }));
    dispatch(moveEngagedAtIndex({ prevIndex: fromIndex, index: toIndex }));
    dispatch(moveStatusAtIndex({ prevIndex: fromIndex, index: toIndex }));
    dispatch(clearValuesAtIndex(fromIndex));
    dispatch(clearEngagedAtIndex(fromIndex));
    dispatch(clearCountersAtIndex(fromIndex));
    dispatch(clearStatusAtIndex(fromIndex));
  };

  const clearFieldSlot = (i) => {
    dispatch(clearValuesAtIndex(i));
    dispatch(clearEngagedAtIndex(i));
    dispatch(clearCountersAtIndex(i));
    dispatch(clearStatusAtIndex(i));
  };

  // When an evolved follower leaves the field, the base card goes to the chosen
  // zone (cemetery/hand/deck) and the evolved card flips face-down back into the
  // evolve deck (status true) — mirroring the right-click "Return to evolve
  // deck" action. No-op for a plain (non-evolved) base card.
  const returnEvoToDeckIfEvolved = (fromIndex) => {
    if (reduxEvoField[fromIndex] === 0) return;
    dispatch(
      backToEvolveDeck({ card: reduxEvoField[fromIndex], index: fromIndex }),
    );
  };

  // Drop handler for dragging the player's own field cards. `dest` is one of:
  //   { type: "field", index } -> move to an empty slot
  //   { type: "cemetery" }     -> send to cemetery
  //   { type: "hand" }         -> return to hand
  //   { type: "deck", half }   -> top/bottom of deck
  // Anything invalid is a no-op (the card snaps back). Cemetery/Hand/Deck mirror
  // the right-click menu. Tokens and advanced cards can't be returned. Evolved
  // followers can: the base card goes to the zone and the evolved card flips
  // back into the evolve deck (returnEvoToDeckIfEvolved).
  const handleFieldDrop = (fromIndex, dest) => {
    // Equipment (in its own equipField) never affects what the follower can
    // do — it just tags along on moves and, being a token, disappears when the
    // follower leaves the field.
    const isEquipAttached = hasEquipAt(fromIndex);
    const isEvo = reduxEvoField[fromIndex] !== 0;
    const baseCard = reduxField[fromIndex];
    const canReturn =
      typeof baseCard === "string" &&
      !isToken(baseCard) &&
      !isAdvanced(baseCard);
    if (dest.type === "cemetery") {
      // Tokens can't be sent to the cemetery — dropping one there removes it
      // from play instead (mirrors the right-click "Remove" action).
      if (typeof baseCard === "string" && isToken(baseCard)) {
        if (isEquipAttached) dispatch(clearEquipmentAtIndex(fromIndex));
        dispatch(removeTokenOnField({ card: baseCard, index: fromIndex }));
        clearFieldSlot(fromIndex);
        return;
      }
      if (!canReturn) return;
      if (isEquipAttached) dispatch(clearEquipmentAtIndex(fromIndex));
      dispatch(placeToCemeteryFromField({ card: baseCard, index: fromIndex }));
      returnEvoToDeckIfEvolved(fromIndex);
      clearFieldSlot(fromIndex);
      return;
    }
    if (dest.type === "hand") {
      if (!canReturn) return;
      if (isEquipAttached) dispatch(clearEquipmentAtIndex(fromIndex));
      dispatch(addToHandFromField({ card: baseCard, index: fromIndex }));
      returnEvoToDeckIfEvolved(fromIndex);
      clearFieldSlot(fromIndex);
      triggerHandReveal(baseCard, reduxCurrentRoom);
      return;
    }
    if (dest.type === "played") {
      if (!canReturn) return;
      if (isEquipAttached) dispatch(clearEquipmentAtIndex(fromIndex));
      dispatch(
        playCardToSharedZone({
          card: baseCard,
          index: fromIndex,
          from: "field",
        }),
      );
      returnEvoToDeckIfEvolved(fromIndex);
      clearFieldSlot(fromIndex);
      return;
    }
    if (dest.type === "deck") {
      if (!canReturn) return;
      if (isEquipAttached) dispatch(clearEquipmentAtIndex(fromIndex));
      if (dest.half === "top")
        dispatch(placeToTopOfDeckFromField({ card: baseCard, index: fromIndex }));
      else dispatch(placeToBotOfDeckFromField({ card: baseCard, index: fromIndex }));
      returnEvoToDeckIfEvolved(fromIndex);
      clearFieldSlot(fromIndex);
      return;
    }
    // field move
    const toIndex = dest.index;
    if (toIndex < 0 || toIndex === fromIndex) return;
    if (reduxField[toIndex] !== 0) {
      // Occupied slot: normally a no-op, but an Equipment token dropped onto a
      // top-row follower attaches to it. Evolved followers are fine targets
      // (equipment has its own slot); already-equipped ones are not.
      const equipping =
        !isEvo &&
        typeof baseCard === "string" &&
        primaryType(baseCard) === "Equipment" &&
        toIndex < 5 &&
        primaryType(reduxField[toIndex]) === "Follower" &&
        !hasEquipAt(toIndex);
      if (!equipping) return;
      dispatch(
        attachEquipmentOnField({
          card: baseCard,
          prevIndex: fromIndex,
          index: toIndex,
        }),
      );
      clearFieldSlot(fromIndex);
      triggerEquipReveal(baseCard, reduxCurrentRoom, toIndex);
      return;
    }
    const cardName = isEvo ? reduxEvoField[fromIndex] : reduxField[fromIndex];
    if (!cardName || cardName === 0) return;
    moveFieldCard(cardName, fromIndex, toIndex, isEvo);
    // An attached equipment marker travels with its follower.
    if (isEquipAttached)
      dispatch(moveEquipmentAtIndex({ prevIndex: fromIndex, index: toIndex }));
    // Promoting from the EX area (5-9) up to the field (0-4) plays the reveal.
    if (fromIndex >= 5 && toIndex < 5)
      triggerCardReveal(cardName, reduxCurrentRoom, toIndex, fieldSlotCenter(toIndex));
  };

  const handleMoveOnField = () => {
    handleClose();
    setReady(true);
    setReadyToMoveOnField(true);
  };
  const handleMoveEvoOnField = () => {
    handleEvoClose();
    setReady(true);
    setReadyToMoveEvoOnField(true);
  };

  const handleTransfer = () => {
    handleClose();
    dispatch(clearEquipmentAtIndex(index));
    dispatch(
      transferToOpponentField({
        card: name,
        prevIndex: index,
      }),
    );
  };

  const handleReturnToEvolveDeck = () => {
    handleEvoClose();
    dispatch(
      backToEvolveDeck({
        card: name,
        index: index,
      }),
    );
  };
  // Dual-sided evolved cards (e.g. Orchis Resolute/Vengeful): flip the evolved
  // card on the field to its other side. Same physical card, so stats/counters/
  // engage stay put; the reveal shows the opponent the new face (Psalm-style).
  const handleSwitchEvoSide = () => {
    handleEvoClose();
    const newCard = doubleEvoOtherSide(name);
    if (!newCard) return;
    dispatch(switchEvoCardOnField({ index }));
    if (index < 5)
      triggerCardReveal(newCard, reduxCurrentRoom, index, fieldSlotCenter(index));
  };
  const handleReturnAdvancedToEvolveDeck = () => {
    handleClose();
    dispatch(
      advancedBackToEvolveDeck({
        card: name,
        index: index,
      }),
    );
  };

  const canPlayCard = (instanceId) =>
    automated &&
    leaderActive &&
    !pendingChoices &&
    instanceId &&
    legalActions.includes(`PLAY:${instanceId}`);

  const canQuickPlayCard = (instanceId) =>
    automated &&
    !pendingChoices &&
    instanceId &&
    legalActions.includes(`QUICK_PLAY:${instanceId}`);

  const canPlayFromExArea = (instanceId) =>
    canPlayCard(instanceId) || canQuickPlayCard(instanceId);

  const canAttackWith = (instanceId) =>
    automated &&
    leaderActive &&
    !pendingChoices &&
    instanceId &&
    legalActions.includes(`ATTACK:${instanceId}`);

  const isValidAttackTarget = (targetId) =>
    selectedAttackerId &&
    legalActions.includes(`ATTACK_TARGET:${selectedAttackerId}:${targetId}`);

  const fieldCombatStyle = (idx, isEnemy) => {
    if (!automated) return {};
    const instanceId = isEnemy
      ? enemyFieldInstanceIds[idx]
      : fieldInstanceIds[idx];
    if (!isEnemy && instanceId && selectedAttackerId === instanceId) {
      return { outline: "3px solid #ff9800", borderRadius: "8px", cursor: "pointer" };
    }
    if (!isEnemy && idx >= 5 && canPlayFromExArea(instanceId)) {
      return {
        outline: canQuickPlayCard(instanceId) ? "2px solid #9c27b0" : "2px solid #2196f3",
        borderRadius: "8px",
        cursor: "pointer",
      };
    }
    if (!isEnemy && idx < 5 && canAttackWith(instanceId)) {
      return { outline: "2px solid #4caf50", borderRadius: "8px", cursor: "pointer" };
    }
    if (isEnemy && selectedAttackerId && isValidAttackTarget(instanceId)) {
      return { outline: "3px solid #f44336", borderRadius: "8px", cursor: "pointer" };
    }
    return {};
  };

  const handleAutomatedPlayerFieldClick = (idx) => {
    const instanceId = fieldInstanceIds[idx];
    if (!instanceId || reduxField[idx] === 0) return;
    if (idx >= 5) {
      if (canQuickPlayCard(instanceId)) {
        sendAction({ type: "QUICK_PLAY", handInstanceId: instanceId });
        return;
      }
      if (canPlayCard(instanceId)) {
        sendAction({ type: "PLAY_CARD", handInstanceId: instanceId });
        return;
      }
      if (legalActions.includes(`ACTIVATE_EXAREA:${instanceId}`)) {
        sendAction({ type: "ACTIVATE_EXAREA", exAreaInstanceId: instanceId });
        return;
      }
      return;
    }
    if (idx < 5 && canAttackWith(instanceId)) {
      dispatch(
        setSelectedAttackerId(selectedAttackerId === instanceId ? null : instanceId),
      );
    }
  };

  const handleAutomatedEnemyFieldClick = (enemyIdx) => {
    if (!automated || !selectedAttackerId || pendingChoices) return;
    const targetId = enemyFieldInstanceIds[enemyIdx];
    if (!targetId || reduxEnemyField[enemyIdx] === 0) return;
    if (!isValidAttackTarget(targetId)) return;
    sendAction({
      type: "ATTACK",
      attackerId: selectedAttackerId,
      targetId,
    });
    dispatch(setSelectedAttackerId(null));
  };

  const getEvolveOptionsForFieldCard = (fieldInstanceId) => {
    const opts = [];
    if (legalActions.includes(`EVOLVE:${fieldInstanceId}`)) {
      opts.push({ useEvoPoint: false, useSuperEvo: false, label: "Evolve" });
    }
    if (legalActions.includes(`SUPER_EVOLVE:${fieldInstanceId}`)) {
      opts.push({ useEvoPoint: false, useSuperEvo: true, label: "Super Evolve" });
    }
    if (legalActions.includes(`EVOLVE_EP:${fieldInstanceId}`)) {
      opts.push({ useEvoPoint: true, useSuperEvo: false, label: "Evolve (use EP)" });
    }
    if (legalActions.includes(`SUPER_EVOLVE_EP:${fieldInstanceId}`)) {
      opts.push({ useEvoPoint: true, useSuperEvo: true, label: "Super Evolve (use EP)" });
    }
    return opts;
  };

  const handleAutomatedFieldContextMenu = (event, idx) => {
    if (!automated || !leaderActive || pendingChoices) return;
    const instanceId = fieldInstanceIds[idx];
    if (!instanceId || reduxField[idx] === 0) return;
    event.preventDefault();
    setAutomatedFieldMenu({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
      idx,
      instanceId,
    });
  };

  const closeAutomatedFieldMenu = () => setAutomatedFieldMenu(null);

  const handleAutomatedEvolve = (useEvoPoint = false, useSuperEvo = false) => {
    if (!automatedFieldMenu) return;
    sendAction({
      type: "EVOLVE",
      fieldInstanceId: automatedFieldMenu.instanceId,
      useEvoPoint: Boolean(useEvoPoint),
      useSuperEvo: Boolean(useSuperEvo),
    });
    closeAutomatedFieldMenu();
  };

  const getActivateOptionsForFieldCard = (fieldInstanceId) => {
    const opts = [];
    if (legalActions.includes(`ACTIVATE:${fieldInstanceId}`)) {
      opts.push({ useEvoPoint: false, label: "Activate" });
    }
    if (legalActions.includes(`ACTIVATE_EP:${fieldInstanceId}`)) {
      opts.push({ useEvoPoint: true, label: "Activate (use EP)" });
    }
    return opts;
  };

  const handleAutomatedActivate = (useEvoPoint = false) => {
    if (!automatedFieldMenu) return;
    sendAction({
      type: "ACTIVATE",
      fieldInstanceId: automatedFieldMenu.instanceId,
      useEvoPoint: Boolean(useEvoPoint),
    });
    closeAutomatedFieldMenu();
  };

  const handleAutomatedActivateExArea = () => {
    if (!automatedFieldMenu) return;
    sendAction({
      type: "ACTIVATE_EXAREA",
      exAreaInstanceId: automatedFieldMenu.instanceId,
    });
    closeAutomatedFieldMenu();
  };

  const handleSelectEnemyCardInHand = (idx) => {
    if (idx === reduxCardSelectedInHand) dispatch(setCardSelectedInHand(-1));
    else dispatch(setCardSelectedInHand(idx));
  };

  const handleSelectEnemyCardOnField = (idx) => {
    if (idx === reduxCardSelectedOnField) dispatch(setCardSelectedOnField(-1));
    else dispatch(setCardSelectedOnField(idx));
  };

  useEffect(() => {
    switch (reduxEnemyCardBack) {
      case "Aenea":
        setCardback(aeneaCardBack);
        break;
      case "Dionne":
        setCardback(dionneCardBack);
        break;
      case "Dragon":
        setCardback(dragonCardBack);
        break;
      case "Filene":
        setCardback(fileneCardBack);
        break;
      case "Galmieux":
        setCardback(galmieuxCardBack);
        break;
      case "Jeanne":
        setCardback(jeanneCardBack);
        break;
      case "Kuon":
        setCardback(kuonCardBack);
        break;
      case "Ladica":
        setCardback(ladicaCardBack);
        break;
      case "Lishenna":
        setCardback(lishennaCardBack);
        break;
      case "Lishenna2":
        setCardback(lishenna2CardBack);
        break;
      case "Mistolina":
        setCardback(mistolinaCardBack);
        break;
      case "Mono":
        setCardback(monoCardBack);
        break;
      case "Orchis":
        setCardback(orchisCardBack);
        break;
      case "Piercye":
        setCardback(piercyeCardBack);
        break;
      case "RoseQueen":
        setCardback(rosequeenCardBack);
        break;
      case "Shikigami":
        setCardback(shikiCardBack);
        break;
      case "Shuten":
        setCardback(shutenCardBack);
        break;
      case "TidalGunner":
        setCardback(tidalgunnerCardBack);
        break;
      case "Viridia":
        setCardback(viridiaCardBack);
        break;
      case "Wilbert":
        setCardback(wilbertCardBack);
        break;
      default:
        setCardback(defaultCardBack);
    }
  }, [reduxEnemyCardBack]);

  return (
    <>
      <Menu
        open={chromeVisible && automatedFieldMenu !== null}
        onClose={closeAutomatedFieldMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          automatedFieldMenu !== null
            ? { top: automatedFieldMenu.mouseY, left: automatedFieldMenu.mouseX }
            : undefined
        }
      >
        {automatedFieldMenu &&
          automatedFieldMenu.idx < 5 &&
          getActivateOptionsForFieldCard(automatedFieldMenu.instanceId).map((opt) => (
            <MenuItem
              key={`activate-${opt.useEvoPoint ? "ep" : "pp"}`}
              onClick={() => handleAutomatedActivate(opt.useEvoPoint)}
            >
              {opt.label}
            </MenuItem>
          ))}
        {automatedFieldMenu &&
          automatedFieldMenu.idx >= 5 &&
          legalActions.includes(`ACTIVATE_EXAREA:${automatedFieldMenu.instanceId}`) && (
            <MenuItem onClick={handleAutomatedActivateExArea}>Activate</MenuItem>
          )}
        {automatedFieldMenu &&
          getEvolveOptionsForFieldCard(automatedFieldMenu.instanceId).map((opt) => (
            <MenuItem
              key={`${opt.useSuperEvo ? "super" : "evo"}-${opt.useEvoPoint ? "ep" : "pp"}`}
              onClick={() => handleAutomatedEvolve(opt.useEvoPoint, opt.useSuperEvo)}
            >
              {opt.label}
            </MenuItem>
          ))}
      </Menu>
      <Menu
        open={chromeVisible && contextMenu !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
      >
        {isAdvanced(name) && (
          <MenuItem onClick={() => handleReturnAdvancedToEvolveDeck()}>
            Return
          </MenuItem>
        )}
        {name === WHITE_PSALM && (
          <MenuItem onClick={() => handleSummonPsalm(BLACK_PSALM)}>
            Summon Black Psalm
          </MenuItem>
        )}
        {name === BLACK_PSALM && (
          <MenuItem onClick={() => handleSummonPsalm(WHITE_PSALM)}>
            Summon White Psalm
          </MenuItem>
        )}
        {isToken(name) && (
          <MenuItem onClick={handleRemoveTokenFromField}>Remove</MenuItem>
        )}
        {isToken(name) && (
          <MenuItem onClick={handleDuplicateToken}>Duplicate</MenuItem>
        )}
        {!isToken(name) && !isAdvanced(name) && (
          <MenuItem onClick={handleCardToPlayedZone}>Play</MenuItem>
        )}
        {!isToken(name) && !isAdvanced(name) && (
          <MenuItem onClick={handleCardToCemetery}>Cemetery</MenuItem>
        )}
        {hasEquipAt(index) && (
          <MenuItem onClick={handleRemoveEquipment}>Remove Equipment</MenuItem>
        )}
        {!reduxCustomValues[index].showAtk && (
          <MenuItem onClick={handleShowAtkDef}>Modify Atk/Def</MenuItem>
        )}
        {reduxCustomValues[index].showAtk && (
          <MenuItem onClick={handleHideAtkDef}>Hide Atk/Def</MenuItem>
        )}
        {reduxCounterField[index] < 1 && (
          <MenuItem onClick={handleAddCounter}>Add Counter</MenuItem>
        )}
        {!isToken(name) && !isAdvanced(name) && (
          <MenuItem onClick={handleCardToHandFromField}>Hand</MenuItem>
        )}
        <MenuItem onClick={handleMoveOnField}>Move</MenuItem>
        {!isToken(name) && !isAdvanced(name) && (
          <MenuItem onClick={handleCardToTopDeck}>Top of Deck</MenuItem>
        )}
        {!isToken(name) && !isAdvanced(name) && (
          <MenuItem onClick={handleCardToBotDeck}>Bot of Deck</MenuItem>
        )}
        {!isToken(name) && !isAdvanced(name) && (
          <MenuItem onClick={handleCardToBanish}>Banish</MenuItem>
        )}

        {!isToken(name) && !isAdvanced(name) && (
          <MenuItem onClick={handleTransfer}>Transfer</MenuItem>
        )}
        {!reduxCustomStatus[index] && (
          <MenuItem onClick={handleShowStatus}>Add Status</MenuItem>
        )}
        {reduxCustomStatus[index] && (
          <MenuItem onClick={handleHideStatus}>Hide Status</MenuItem>
        )}
        {reduxCustomStatus[index] &&
          KEYWORDS.map((kw) => (
            <MenuItem key={kw} onClick={() => handleToggleKeyword(kw)}>
              {(reduxKeywordField[index] || []).includes(kw) ? "✓ " : ""}
              {kw}
            </MenuItem>
          ))}
      </Menu>
      <Menu
        open={chromeVisible && contextEvoMenu !== null}
        onClose={handleEvoClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextEvoMenu !== null
            ? { top: contextEvoMenu.mouseY, left: contextEvoMenu.mouseX }
            : undefined
        }
      >
        <MenuItem onClick={() => handleReturnToEvolveDeck()}>Return</MenuItem>
        {doubleEvoOtherSide(name) && (
          <MenuItem onClick={handleSwitchEvoSide}>Switch Side</MenuItem>
        )}
        {hasEquipAt(index) && (
          <MenuItem onClick={handleRemoveEquipment}>Remove Equipment</MenuItem>
        )}
        <MenuItem onClick={handleMoveEvoOnField}>Move</MenuItem>
        {!reduxCustomValues[index].showAtk && (
          <MenuItem onClick={handleShowAtkDef}>Modify Atk/Def</MenuItem>
        )}
        {reduxCustomValues[index].showAtk && (
          <MenuItem onClick={handleHideAtkDef}>Hide Atk/Def</MenuItem>
        )}
        {!reduxCustomStatus[index] && (
          <MenuItem onClick={handleShowStatus}>Add Status</MenuItem>
        )}
        {reduxCustomStatus[index] && (
          <MenuItem onClick={handleHideStatus}>Hide Status</MenuItem>
        )}
        {reduxCounterField[index] < 1 && reduxCustomStatus[index] && (
          <MenuItem onClick={handleAddCounter}>Add Counter</MenuItem>
        )}
        {reduxCustomStatus[index] &&
          KEYWORDS.map((kw) => (
            <MenuItem key={kw} onClick={() => handleToggleKeyword(kw)}>
              {(reduxKeywordField[index] || []).includes(kw) ? "✓ " : ""}
              {kw}
            </MenuItem>
          ))}
      </Menu>

      {/* Show Enemy Card Modal */}

      <Modal
        open={enemyCardModalOpen}
        onClose={handleShowCardModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          "& > .MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "transparent",
            boxShadow: 24,
            // p: 3,
            width: 0,
            border: "none",
          }}
        >
          <HideUiButton
            sx={{ position: "fixed", top: 16, left: 16, zIndex: 1400 }}
          />
          <CardMUI
            sx={{
              backgroundColor: "transparent",
              width: "100%",
              // height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "none",
              overflow: "visible",
            }}
            variant="outlined"
          >
            <motion.div
              initial={{ scale: 1.0, rotateY: 180 }}
              transition={{ duration: 0.8 }}
              animate={{ scale: 4.5, rotateY: 0 }}
              // variants={{
              //   start: {
              //     scale: 4.5,
              //     rotateY: [0, 360],
              //     transition: {
              //       duration: 0.8,
              //       ease: "linear",
              //     },
              //   },
              // }}
              // animate={["start"]}
            >
              <img
                className={"cardStyle"}
                src={artImage(reduxEnemyCard, reduxEnemyArt)}
                alt={reduxEnemyCard}
              />
            </motion.div>
          </CardMUI>
        </Box>
      </Modal>

      {/* Show Enemy Revealed Top Cards Modal */}

      <Modal
        open={enemyRevealedCardsModalOpen}
        onClose={handleShowRevealedCardsModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          "& > .MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box sx={style}>
          <ModalHideUiRow />
          <Typography
            sx={{
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "Noto Serif JP, serif",
              fontSize: "20px",
              margin: "0 0 1em 0",
            }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Viewing Opponent's Top Cards
          </Typography>
          <CardMUI
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              minHeight: "250px",
              padding: "3%",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
            variant="outlined"
          >
            {reduxEnemyRevealedCards.map((card, idx) => (
              <div key={`card-${idx}`}>
                <Card name={card} setHovering={setHovering} />
              </div>
            ))}
          </CardMUI>
        </Box>
      </Modal>

      {/* Three-zone layout that fills the available height: the opponent's
          hand is pinned to the top edge, the field is centered in the space
          between the two hands, and the player's hand is pinned to the bottom
          (rendered in Game.js). Both zones scale by the same boardScale so the
          cards and their pixel-tuned overlays stay aligned at any resolution. */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Opponent hand — pinned to the top */}
        <div
          style={{
            flexShrink: 0,
            transform: `scale(${boardScale})`,
            transformOrigin: "top center",
          }}
        >
          <div
            ref={(el) => registerEnemyHand(el)}
            style={{
              position: "relative",
              width: `${BASE_WIDTH}px`,
              display: "flex",
              flexDirection: "row",
              // Reserve one card's height at all times (cardbacks are 161px tall,
              // see .cardStyle). The old 130px minHeight was shorter than a card,
              // so the opponent drawing their first card (or playing their last)
              // grew this row ~31px and shoved the whole board down for the
              // viewer. A constant height keeps the board fixed, matching the
              // player-side hand fix.
              height: "161px",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "2em",
            }}
          >
            {reduxEnemyHand.map((card, idx) => {
              // Keep the opponent's hand within the board width: while the cards
              // fit they sit side by side, but once they'd overflow (cardbacks
              // are 115px wide, so ~10 cards for the BASE_WIDTH board) a shared
              // negative margin overlaps them so the hand stays within BASE_WIDTH.
              const n = reduxEnemyHand.length;
              const ENEMY_CARD_W = 115;
              const overlap =
                n > 1
                  ? Math.max(0, (n * ENEMY_CARD_W - BASE_WIDTH) / (n - 1))
                  : 0;
              const baseStyle = {
                cursor: `url(${img}) 55 55, auto`,
                marginLeft: idx === 0 ? 0 : -overlap,
                visibility: enemyShuffling ? "hidden" : "visible",
              };
              return (
                <img
                  style={
                    reduxCardSelectedInHand === idx
                      ? {
                          ...baseStyle,
                          filter:
                            "sepia() saturate(4) hue-rotate(315deg) brightness(100%) opacity(5)",
                        }
                      : baseStyle
                  }
                  key={idx}
                  className={"cardStyle"}
                  // When the opponent has shown their hand, render the actual
                  // cards face-up in place of the usual cardbacks.
                  src={
                    reduxShowEnemyHand
                      ? artImage(card, reduxEnemyArt)
                      : cardback
                  }
                  alt={reduxShowEnemyHand ? card : "cardback"}
                  onClick={() => handleSelectEnemyCardInHand(idx)}
                />
              );
            })}
            <HandFx side="enemy" />
          </div>
        </div>

        {/* Field — centered between the two hands */}
        <div
          ref={boardWrapperRef}
          style={{
            flex: 1,
            minHeight: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            ref={boardRef}
            style={{
              width: `${BASE_WIDTH}px`,
              flexShrink: 0,
              transform: `scale(${boardScale})`,
              transformOrigin: "center",
            }}
          >

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          minHeight: "330px",
          alignItems: "end",
        }}
      >
        {/* Enemy Deck and Cemetery */}

        <div
          style={{
            minHeight: "330px",
            width: `${SIDE_COLUMN_WIDTH}px`,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            // backgroundColor: "rgba(0, 0, 0, 0.60)",
            // background: "linear-gradient(to bottom, #09203f 0%, #537895 100%)",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <div style={{ position: "relative" }}>
            <div
            // style={{
            //   cursor: `url(${img}) 55 55, auto`,
            // }}
            >
              <img
                className={"cardStyle"}
                src={cardback}
                alt={"cardback"}
                style={{ visibility: enemyDeckShuffling ? "hidden" : "visible" }}
              />
            </div>
            <DeckFx side="enemy" />
            {/* {showOpponentDeckSize && ( */}
            <div
              style={{
                width: "50px",
                position: "absolute",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                top: "5%",
                right: "30%",
                color: "rgba(255, 255, 255, 1)",
                fontSize: "30px",
                fontFamily: "Noto Serif JP, serif",
              }}
            >
              {reduxEnemyDeckSize}
            </div>
            {/* )} */}
          </div>

          <EnemyCemetery setHovering={setHovering} ready={ready} />
        </div>

        {/* Enemy Field (1-5) & Ex Area (6-10) */}
        <div
          ref={(el) => registerEnemyFieldGrid(el)}
          style={{
            minHeight: "330px",
            flex: 1,
            minWidth: 0,
            // backgroundColor: "black",
            // backgroundColor: "#131219",
            // backgroundColor: "rgba(0, 0, 0, 0.60)",
            // background: "linear-gradient(to bottom, #09203f 0%, #537895 100%)",
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            columnGap: "60px",
            paddingInline: `${FIELD_GRID_PADDING_X}px`,
            alignItems: "center",
            justifyItems: "center",
            // zIndex: 0,
          }}
        >
          {/* <span
            style={{
              fontFamily: "Noto Serif JP, serif",
              fontSize: "1.2em",
              color: "#E0FFFF",
              textShadow: "1px 1px 10px #E0FFFF, 1px 1px 10px #ccc",
              position: "absolute",
              top: "35%",
              width: "50px",
              pointerEvents: "none",
            }}
          >
            Field
          </span>
          <span
            style={{
              fontFamily: "Noto Serif JP, serif",
              fontSize: "1.2em",
              color: "#E0FFFF",
              textShadow: "1px 1px 10px #E0FFFF, 1px 1px 10px #ccc",
              position: "absolute",
              top: "18%",
              width: "100px",
              pointerEvents: "none",
            }}
          >
            EX Area
          </span> */}
          {reduxField.map((x, idx) => (
            <motion.div
              key={`enemy1-${idx}`}
              className={"cardStyle fieldSlot"}
              style={{
                zIndex: 2,
                ...fieldCombatStyle(cardPos(idx), true),
              }}
              onClick={() => {
                const enemyIdx = cardPos(idx);
                if (automated && selectedAttackerId) {
                  handleAutomatedEnemyFieldClick(enemyIdx);
                  return;
                }
                handleSelectEnemyCardOnField(enemyIdx);
              }}
            >
              {reduxEnemyField[cardPos(idx)] !== 0 &&
                reduxEnemyEvoField[cardPos(idx)] === 0 && (
                  <Card
                    atkVal={reduxEnemyCustomValues[cardPos(idx)].atk}
                    defVal={reduxEnemyCustomValues[cardPos(idx)].def}
                    showAtk={reduxEnemyCustomValues[cardPos(idx)].showAtk}
                    showDef={reduxEnemyCustomValues[cardPos(idx)].showDef}
                    engaged={reduxEnemyEngaged[cardPos(idx)]}
                    counterVal={reduxEnemyCounterField[cardPos(idx)]}
                    discountedPlayCost={reduxEnemyExPlayCostField[cardPos(idx)]}
                    aura={reduxEnemyAuraField[cardPos(idx)]}
                    bane={reduxEnemyBaneField[cardPos(idx)]}
                    ward={reduxEnemyWardField[cardPos(idx)]}
                    keywords={reduxEnemyKeywordField[cardPos(idx)]}
                    opponentField={true}
                    onField={true}
                    idx={idx}
                    key={`enemy-card-${cardPos(idx)}`}
                    name={reduxEnemyField[cardPos(idx)]}
                    equipCard={reduxEnemyEquipField[cardPos(idx)]}
                    setHovering={setHovering}
                    ready={ready}
                    hidden={isHidden("enemy", cardPos(idx))}
                  />
                )}
              {reduxEnemyEvoField[cardPos(idx)] !== 0 && (
                <Card
                  atkVal={reduxEnemyCustomValues[cardPos(idx)].atk}
                  defVal={reduxEnemyCustomValues[cardPos(idx)].def}
                  showAtk={reduxEnemyCustomValues[cardPos(idx)].showAtk}
                  showDef={reduxEnemyCustomValues[cardPos(idx)].showDef}
                  engaged={reduxEnemyEngaged[cardPos(idx)]}
                  counterVal={reduxEnemyCounterField[cardPos(idx)]}
                  aura={reduxEnemyAuraField[cardPos(idx)]}
                  bane={reduxEnemyBaneField[cardPos(idx)]}
                  ward={reduxEnemyWardField[cardPos(idx)]}
                  keywords={reduxEnemyKeywordField[cardPos(idx)]}
                  opponentField={true}
                  onField={true}
                  idx={idx}
                  key={`enemy-evo-${cardPos(idx)}`}
                  name={reduxEnemyEvoField[cardPos(idx)]}
                  equipCard={reduxEnemyEquipField[cardPos(idx)]}
                  setHovering={setHovering}
                  ready={ready}
                  cardBeneath={reduxEnemyField[cardPos(idx)]}
                  hidden={isHidden("enemy", cardPos(idx))}
                />
              )}
            </motion.div>
          ))}
        </div>
        {/* Enemy Evolve Deck */}
        <div
          style={{
            minHeight: "330px",
            width: `${SIDE_COLUMN_WIDTH}px`,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            // backgroundColor: "black",
            // backgroundColor: "#131219",
            // background: "linear-gradient(to bottom, #09203f 0%, #537895 100%)",
            // backgroundColor: "rgba(0, 0, 0, 0.60)",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "8px",

            // cursor: `url(${img}) 55 55, auto`,
          }}
        >
          <EnemyEvoDeck setHovering={setHovering} ready={ready} />
          <PlayedZone
            setReadyFromPlayed={setReadyFromPlayed}
            setReady={setReady}
            setHovering={setHovering}
            ready={ready}
          />
        </div>
      </div>

      {/* Player */}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          minHeight: "330px",
          cursor: ready && `url(${img}) 55 55, auto`,
        }}
      >
        {/* Player Evolve Deck */}
        <div
          style={{
            minHeight: "330px",
            width: `${SIDE_COLUMN_WIDTH}px`,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <EvoDeck
            setReadyToEvo={setReadyToEvo}
            setReadyToAdvanced={setReadyToAdvanced}
            setReadyToFeed={setReadyToFeed}
            setReadyToRide={setReadyToRide}
            setReady={setReady}
            setHovering={setHovering}
            ready={ready}
          />
          <ShowDice />
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <Token
              setReady={setReady}
              setHovering={setHovering}
              ready={ready}
              setTokenReady={setTokenReady}
            />
            {/* <Lesson /> */}
          </div>
        </div>
        {/* Player Field (1-5) & Ex Area (6-10) */}
        {/* Divide pointer coords by boardScale so a dragged field card tracks
            the cursor 1:1 — without this the card lags by `boardScale` because
            framer-motion's translate is multiplied by the board's CSS scale. */}
        <MotionConfig transformPagePoint={transformPagePoint}>
        <div
          ref={(el) => registerFieldGrid(el)}
          style={{
            minHeight: "330px",
            flex: 1,
            minWidth: 0,
            // backgroundColor: "black",
            // backgroundColor: "#131219",
            // backgroundColor: "rgba(0, 0, 0, 0.60)",
            // padding: "2em",
            // background: "linear-gradient(to top, #09203f 0%, #537895 100%)",
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            columnGap: "60px",
            paddingInline: `${FIELD_GRID_PADDING_X}px`,
            alignItems: "center",
            justifyItems: "center",
            // zIndex: 0,
          }}
        >
          <span
            style={{
              fontFamily: "Noto Serif JP, serif",
              fontSize: "1.2em",
              color: "#E0FFFF",
              textShadow: "1px 1px 10px #E0FFFF, 1px 1px 10px #ccc",
              position: "absolute",
              bottom: "45%",
              width: "50px",
              pointerEvents: "none",
              zIndex: 0,
            }}
          >
            Field
          </span>
          <span
            style={{
              fontFamily: "Noto Serif JP, serif",
              fontSize: "1.2em",
              color: "#E0FFFF",
              textShadow: "1px 1px 10px #E0FFFF, 1px 1px 10px #ccc",
              position: "absolute",
              bottom: "28%",
              width: "100px",
              pointerEvents: "none",
            }}
          >
            EX Area
          </span>
          {reduxField.map((card, idx) => (
            <div className="fieldSlot" key={`card-${idx}`}>
              {ready && (
                <motion.div
                  onClick={() => {
                    handleClick(reduxCurrentCard, idx);
                  }}
                  onContextMenu={() => {
                    cancelClick();
                  }}
                  key={`player1-${idx}`}
                  style={
                    {
                      // height: "160px",
                      // width: "115px",
                      // backgroundColor: "rgba(255, 255, 255, 0.1)",
                      // backgroundColor: "#131219",
                      // borderRadius: "10px",
                    }
                  }
                  className={
                    reduxField[idx] !== 0 &&
                    reduxEvoField[idx] === 0 &&
                    (readyToEvo || readyToFeed || readyToRide)
                      ? "box"
                      : reduxField[idx] === 0 &&
                          !readyToEvo &&
                          !readyToFeed &&
                          !readyToRide
                        ? "box"
                        : "none"
                  }
                >
                  {reduxField[idx] !== 0 && reduxEvoField[idx] === 0 && (
                    <Card
                      showAtk={reduxCustomValues[idx].showAtk}
                      showDef={reduxCustomValues[idx].showDef}
                      atkVal={reduxCustomValues[idx].atk}
                      defVal={reduxCustomValues[idx].def}
                      engaged={reduxEngaged[idx]}
                      counterVal={reduxCounterField[idx]}
                      discountedPlayCost={reduxExPlayCostField[idx]}
                      aura={reduxAuraField[idx]}
                      bane={reduxBaneField[idx]}
                      ward={reduxWardField[idx]}
                      keywords={reduxKeywordField[idx]}
                      idx={idx}
                      onField={true}
                      key={`card1-${idx}`}
                      name={card}
                      equipCard={reduxEquipField[idx]}
                      setHovering={setHovering}
                      ready={ready}
                    />
                  )}
                  {reduxEvoField[idx] !== 0 && (
                    <Card
                      showAtk={reduxCustomValues[idx].showAtk}
                      showDef={reduxCustomValues[idx].showDef}
                      atkVal={reduxCustomValues[idx].atk}
                      defVal={reduxCustomValues[idx].def}
                      engaged={reduxEngaged[idx]}
                      counterVal={reduxCounterField[idx]}
                      idx={idx}
                      onField={true}
                      key={`evo1-${idx}`}
                      name={reduxEvoField[idx]}
                      equipCard={reduxEquipField[idx]}
                      setHovering={setHovering}
                      ready={ready}
                      cardBeneath={reduxField[idx]}
                    />
                  )}
                </motion.div>
              )}
              {!ready && (
                <div
                  onClick={() => {
                    if (automated) handleAutomatedPlayerFieldClick(idx);
                  }}
                  onContextMenu={(e) => {
                    if (automated) {
                      handleAutomatedFieldContextMenu(e, idx);
                      return;
                    }
                    if (reduxField[idx] !== 0 && reduxEvoField[idx] === 0)
                      handleContextMenu(e, idx, reduxField[idx]);
                    else if (reduxField[idx] !== 0)
                      handleEvoContextMenu(e, idx, reduxEvoField[idx]);
                  }}
                  key={`player2-${idx}`}
                  style={fieldCombatStyle(idx, false) }
                  className={"cardStyle"} 
                >
                  {reduxField[idx] !== 0 && reduxEvoField[idx] === 0 && (
                    <Card
                      showAtk={reduxCustomValues[idx].showAtk}
                      showDef={reduxCustomValues[idx].showDef}
                      atkVal={reduxCustomValues[idx].atk}
                      defVal={reduxCustomValues[idx].def}
                      engaged={reduxEngaged[idx]}
                      counterVal={reduxCounterField[idx]}
                      discountedPlayCost={reduxExPlayCostField[idx]}
                      aura={reduxAuraField[idx]}
                      bane={reduxBaneField[idx]}
                      ward={reduxWardField[idx]}
                      keywords={reduxKeywordField[idx]}
                      idx={idx}
                      onField={true}
                      key={`card2-${idx}`}
                      name={reduxField[idx]}
                      equipCard={reduxEquipField[idx]}
                      setHovering={setHovering}
                      ready={ready}
                      onFieldDrop={handleFieldDrop}
                      hidden={isHidden("mine", idx)}
                    />
                  )}
                  {reduxEvoField[idx] !== 0 && (
                    <Card
                      showAtk={reduxCustomValues[idx].showAtk}
                      showDef={reduxCustomValues[idx].showDef}
                      atkVal={reduxCustomValues[idx].atk}
                      defVal={reduxCustomValues[idx].def}
                      engaged={reduxEngaged[idx]}
                      counterVal={reduxCounterField[idx]}
                      discountedPlayCost={reduxExPlayCostField[idx]}
                      aura={reduxAuraField[idx]}
                      bane={reduxBaneField[idx]}
                      ward={reduxWardField[idx]}
                      keywords={reduxKeywordField[idx]}
                      idx={idx}
                      onField={true}
                      key={`evo2-${idx}`}
                      name={reduxEvoField[idx]}
                      equipCard={reduxEquipField[idx]}
                      setHovering={setHovering}
                      ready={ready}
                      cardBeneath={reduxField[idx]}
                      onFieldDrop={handleFieldDrop}
                      hidden={isHidden("mine", idx)}
                    />
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
        </MotionConfig>

        {/* Player Deck and Cemetery - stacked so the Cemetery sits directly
            below the shared Played zone and the Deck stays in the same row. */}
        <div
          style={{
            minHeight: "330px",
            width: `${SIDE_COLUMN_WIDTH}px`,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            // backgroundColor: "black",
            // backgroundColor: "#131219",
            zIndex: 0,
            // background: "linear-gradient(to top, #09203f 0%, #537895 100%)",
            // backgroundColor: "rgba(0, 0, 0, 0.60)",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "8px",
            // cursor: `url(${img}) 55 55, auto`,
          }}
        >
          <Cemetery
            setReadyFromCemetery={setReadyFromCemetery}
            setReadyFromBanish={setReadyFromBanish}
            setReady={setReady}
            setHovering={setHovering}
            ready={ready}
          />
          <div style={{ zIndex: -1, position: "relative" }}>
            <Deck
              setHovering={setHovering}
              ready={ready}
              setReadyFromDeck={setReadyFromDeck}
              setReady={setReady}
              setDeckIndex={setDeckIndex}
            />
            {/* {showOpponentDeckSize && ( */}
            <div
              style={{
                position: "absolute",
                width: "50px",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                top: "65%",
                right: "27%",
                color: "rgba(255, 255, 255, 1)",
                fontSize: "30px",
                fontFamily: "Noto Serif JP, serif",
              }}
            >
              {reduxCurrentDeck.length || 0}
            </div>
            {/* )} */}
          </div>
        </div>
      </div>
      {/* Drop-zone hints shown while dragging a card from the hand. */}
      <FieldDropHints />
      {/* Dice toss animation (shown to both players). */}
      <DiceRoll />
      {/* "Card played" reveal: shows the card centre-screen, then onto the field. */}
      <PlayReveal />
        </div>
      </div>
      </div>
    </>
  );
}
